export default __webpack_public_path__ + "images/e490de47d8e2dfeeca5f87c97d80e617.png";